import PropTypes from 'prop-types';
import React, {PureComponent} from 'react';
import {StyleSheet, View} from 'react-native';
import {ActivityIndicator, Text, Touchable} from 'trpc-react-native-ui';
import BaseFrame from './BaseFrame';
import Content from './Content';
import ToggleFrameButton from './ToggleFrameButton';

function getStyles() {
  return StyleSheet.create({
    headerFrame: {
      borderBottomWidth: 1,
      borderBottomColor: '#cccccc',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingBottom: 5,
    },
    titleOnlyFrame: {
      justifyContent: 'flex-start',
    },
    loader: {
      height: 100,
    },
  });
}

class Frame extends PureComponent {
  styles = getStyles();

  render() {
    const styles = this.styles;
    const {isLoading = false, headerTouchableOnly = false} = this.props;
    const content = isLoading ? (
      <ActivityIndicator style={styles.loader} />
    ) : (
      this.props.children
    );

    return (
      <BaseFrame
        onFrameTouched={headerTouchableOnly ? null : this.props.onToggleFolded}
        style={this.props.style}>
        {this.props.title && (
          <Touchable
            testID={this.props.headerTestID}
            onPress={
              typeof this.props.onToggleFolded === 'function'
                ? this.props.onToggleFolded
                : null
            }
            underlayColor="white">
            <View
              style={[
                styles.headerFrame,
                !this.props.onToggleFolded && styles.titleOnlyFrame,
                this.props.titleContainerStyle,
              ]}>
              <Text style={{fontWeight: '600'}}>{this.props.title}</Text>
              {this.props.isLoadingForToggling ? (
                <ActivityIndicator />
              ) : this.props.onToggleFolded ? (
                <ToggleFrameButton title={this.props.toggleTitle} />
              ) : null}
            </View>
          </Touchable>
        )}
        {content}
      </BaseFrame>
    );
  }
}

Frame.propTypes = {
  title: PropTypes.string,
  headerTestID: PropTypes.string,
  isLoadingForToggling: PropTypes.bool,
  toggleTitle: PropTypes.string,
  onToggleFolded: PropTypes.func,
  folded: PropTypes.bool,
  isLoading: PropTypes.bool,
  children: PropTypes.any,
  headerTouchableOnly: PropTypes.bool,
  style: PropTypes.any,
  titleContainerStyle: PropTypes.any,
};

Frame.Content = Content;

export default Frame;
